<div class="container glovo-wallet">
  <svg-icon key="cross-yellow" class="glovo-wallet__close" (click)="close()" aria-label="close"></svg-icon>
  <div class="row">
    <div class="col-12 col-md-6 order-md-1 order-2">
      <div class="glovo-wallet__title">{{ 'COMMON.WALLET.TITLE' | translate }}</div>
      <div class="glovo-wallet__description">{{ 'COMMON.WALLET.DESCRIPTION' | translate : { shopName: shopName} }}</div>
      <div class="glovo-wallet__advantages">{{ 'COMMON.WALLET.ADVANTAGES' | translate }}</div>
      <ul>
        <li>
          <p class="glovo-wallet__advantages-description">
            <span class="glovo-wallet__advantages-title">{{ 'COMMON.WALLET.ADVANTAGE_1.TITLE' | translate }}</span>
            {{ 'COMMON.WALLET.ADVANTAGE_1.DESCRIPTION_PART1' | translate : { shopName: shopName } }}
            <span class='glovo-wallet__advantages-description-highlighted'>{{ 'COMMON.WALLET.ADVANTAGE_1.DESCRIPTION_PART2' | translate }}</span>
          </p>
        </li>
        <li>
          <p class="glovo-wallet__advantages-description">
            <span class="glovo-wallet__advantages-title">{{ 'COMMON.WALLET.ADVANTAGE_2.TITLE' | translate }}</span>
            {{ 'COMMON.WALLET.ADVANTAGE_2.DESCRIPTION' | translate }}
          </p>
        </li>
      </ul>
      <div class="glovo-wallet__conditions">{{ 'COMMON.WALLET.CONDITIONS_1' | translate }}</div>
      <div class="glovo-wallet__conditions" [innerHTML]="'COMMON.WALLET.CONDITIONS_2' | translate"></div>
      <div class="glovo-wallet__conditions mb-5">{{ 'COMMON.WALLET.CONDITIONS_3' | translate }}</div>
    </div>
    <div class="col-12 col-md-6 order-md-2 order-1 glovo-wallet__image">
      <svg-icon key="glovo-wallet" *ngIf="!isMobile" class="image" aria-label="glovo-wallet"></svg-icon>
      <svg-icon key="glovo-wallet-mobile" *ngIf="isMobile" class="image" aria-label="glovo-wallet"></svg-icon>
    </div>
  </div>
</div>
